import { MixpanelEventSource, MixpanelSourceProvider } from '@talos/kyoko';
import { PositionAutoHedgingRules } from '../../../../containers/Trading/Markets/PositionAutoHedgingRules';
import type { PositionAutoHedgingRulesPanelConfig } from '../../../../types/LayoutConfig';
import { Panel } from '../../../Layout/Components/Panel';
import type { LayoutPanelProps } from '../../types';

export function PositionAutohedgingRulesPanel({ api }: LayoutPanelProps<PositionAutoHedgingRulesPanelConfig>) {
  return (
    <MixpanelSourceProvider value={MixpanelEventSource.PositionAutoHedging}>
      <Panel panelApi={api} data-testid="position-autohedging-rules-panel">
        <PositionAutoHedgingRules tabId={api.id} />
      </Panel>
    </MixpanelSourceProvider>
  );
}
